import { useState, useEffect } from "react"
import AsteriskSymbol from "../../../../reusableComponents/AsteriskSymbol";
import Select from "react-select"
import { toast } from "react-toastify";
import { REACT_APP_KSHEMA_POC2 } from "../../../../urls";
import { axiosRequest } from "../../../../service";
import { getAdvanceSearchResults } from "./apiHelper";
import { fetchDistricts, fetchMandals, fetchPincodeList, fetchStates, fetchVillages } from "../../../apiHelper";

const AdvanceSearch = (props) => {
    const { searchFields, setSearchFields, showAdvanceSearch, setSearchResults } = props
    const [statesList, setStatesList] = useState([]);
    const [districtList, setDistrictList] = useState([]);
    const [mandalList, setMandalList] = useState([]);
    const [villageList, setVillageList] = useState([]);
    const [pincodeList, setPincodeList] = useState([]);
    const resetFields = {
        state: "",
        district: "",
        mandal: "",
        village: "",
        pincode: "",
        policyHolderName: "",
    }

    const advanceSearch = async () => {
        if (!searchFields.product_name) {
            toast.error("Please Select Product Name");
            return;
        }
        if (!searchFields.state) {
            toast.error("Please Select State");
            return;
        }
        if (!searchFields.district) {
            toast.error("Please Select District");
            return;
        }
        if (!searchFields.mandal) {
            toast.error("Please Select Mandal");
            return;
        }
        if (!searchFields.village) {
            toast.error("Please Select Village");
            return;
        }
        setSearchResults([]);
        // const data = await getAdvanceSearchResults(searchFields)

        // if (data?.data && data.data !== "No Data Present") {
        //     setList(data.data)
        // }
        // else { 
        //     setList([]); 
        // }
        // setSearchResults(true);
    }

    useEffect(() => {
        getStatesList();
    }, []);

 const getStatesList = async () => {
        const fetchedStates = await fetchStates();
        setStatesList(fetchedStates);
    };

    const getDistrictList = async (state) => {
        const fetchedDistricts = await fetchDistricts(state);
        setDistrictList(fetchedDistricts);
    };

    const getMandalList = async (district, state=searchFields.state) => {
        if (district && state) {
        const fetchedMandals = await fetchMandals(district, state);
        setMandalList(fetchedMandals);
        }
    };

    const getVillageList = async (mandal, district=searchFields.mandal, state=searchFields.state) => {
    if (mandal && district && state) {
    const fetchedVillages = await fetchVillages(mandal, district=searchFields.district, state=searchFields.state);
    setVillageList(fetchedVillages);
    }
    };

    const getPincodeList = async (village, mandal=searchFields.mandal, district=searchFields.district, state=searchFields.state) => {
        const setPinCode = (pincode) => {
            setSearchFields({...searchFields, village: village, pincode: pincode})
        }
        if(village) {
            const fetchedPincodes = await fetchPincodeList(village, mandal, district, state, setPinCode)
            setPincodeList(fetchedPincodes)
        }
    };

    return (
        <div>
            {showAdvanceSearch && (
                <div className="border rounded p-4 px-1">
                    <h5 className="ms-4">Advance Search</h5>
                    <div className="d-md-flex align-items-center justify-content-evenly mt-3">
                        <div className="form-group w-23">
                            <label>
                                State <AsteriskSymbol />
                            </label>
                            <Select
                                options={statesList}
                                classNamePrefix="bg-gray"
                                placeholder="Select State"
                                value={
                                    searchFields.state
                                        ? { label: searchFields.state, value: searchFields.state }
                                        : null
                                }
                                onChange={(data) => {
                                    getDistrictList(data.value);
                                    setSearchFields({
                                        ...searchFields,
                                        state: data.value,
                                        district: "",
                                        mandal: "",
                                        village: "",
                                        pincode: "",
                                    });
                                }}
                            />
                        </div>
                        <div className="form-group w-23">
                            <label>
                                District <AsteriskSymbol />
                            </label>
                            <Select
                                options={districtList}
                                classNamePrefix="bg-gray"
                                placeholder="Select District"
                                isDisabled={!searchFields.state}
                                value={
                                    searchFields.district
                                        ? {
                                            label: searchFields.district,
                                            value: searchFields.district,
                                        }
                                        :  null
                                }
                                onChange={(data) => {
                                    getMandalList(data.value);
                                    setSearchFields({
                                        ...searchFields,
                                        district: data.value,
                                        mandal: "",
                                        village: "",
                                        pincode: "",
                                    });
                                }}
                            />
                        </div>
                        <div className="form-group w-23">
                            <label>
                                Mandal <AsteriskSymbol />
                            </label>
                            <Select
                                options={mandalList}
                                classNamePrefix="bg-gray"
                                placeholder="Select Mandal"
                                isDisabled={!searchFields.district}
                                value={
                                    searchFields.mandal
                                        ? {
                                            label: searchFields.mandal,
                                            value: searchFields.mandal,
                                        }
                                        : null
                                }
                                onChange={(data) => {
                                    getVillageList(data.value);
                                    setSearchFields({
                                        ...searchFields,
                                        mandal: data.value,
                                        village: "",
                                        pincode: "",
                                    });
                                }}
                            />
                        </div>
                        <div className="form-group w-23">
                            <label>
                                Village <AsteriskSymbol />
                            </label>
                            <Select
                                options={villageList}
                                classNamePrefix="bg-gray"
                                placeholder="Select Village"
                                isDisabled={!searchFields.mandal}
                                value={
                                    searchFields.village
                                        ? {
                                            label: searchFields.village,
                                            value: searchFields.village,
                                        }
                                        : null
                                }
                                onChange={(data) => {
                                    getPincodeList(data.value);
                                    setSearchFields({
                                        ...searchFields,
                                        village: data.value,
                                        pincode: "",
                                    });
                                }}
                            />
                        </div>
                    </div>
                    <div className="d-md-flex align-items-center justify-content-evenly mt-4">
                        <div className="form-group w-23">
                            <label>Pincode</label>
                            <Select
                                options={pincodeList}
                                classNamePrefix="bg-gray"
                                placeholder="Select Pincode"
                                isDisabled={!searchFields.village}
                                value={
                                    searchFields.pincode
                                        ? {
                                            label: searchFields.pincode,
                                            value: searchFields.pincode,
                                        }
                                        : null
                                }
                            />
                        </div>
                        <div className="form-group w-23">
                            <label>Policy Holder Name</label>
                            <input
                                type="text"
                                className="form-control bg-gray"
                                disabled={!searchFields.state}
                                placeholder="Enter Policy Holder Name"
                                onChange={(e) => {
                                    setSearchFields({
                                        ...searchFields,
                                        policyHolderName: e.target.value,
                                    });
                                }}
                                value={searchFields.policyHolderName}
                            />
                        </div>
                        <div className="form-group w-23"></div>
                        <div className="form-group w-23"></div>
                    </div>
                    <div className="d-flex ms-3 justify-content-between">
                        <div className="d-flex">
                            <div className="form-group">
                                <button
                                    className="btn btn-success m-4 mb-0 px-4"
                                    onClick={() => {
                                        advanceSearch();
                                    }}
                                >
                                    Search
                                </button>
                            </div>
                            <div className="form-group">
                                <div
                                    className="btn btn-outline-success mt-4 mb-0 px-4"
                                    onClick={() => {
                                        setSearchFields({ ...searchFields, ...resetFields });
                                        setSearchResults(null);
                                    }}
                                >
                                    Reset
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    )
}

export default AdvanceSearch;